module.exports = "/_next/static/images/hand-line-886a477ef5fc3d433a698ab82a74aad0.svg";